import {
	array,
	boolean,
	intersect,
	nullable,
	number,
	partial,
	record,
	string,
	struct,
	union,
} from 'io-ts/Decoder';

import { AdditionalParameterValue } from '../../../../../whole-house/canvas/recipe/AdditionalParameterValue';
import { Id as FormulaUsageId } from '../../../../../whole-house/formula/usage/Id';
import { Id as MaterialTemplateUsageId } from '../../../../../whole-house/material-template/usage/Id';

const MaterialRef = intersect(
	struct({
		materialTemplateUsageId: MaterialTemplateUsageId,
		formulaUsageId: FormulaUsageId,
	})
)(
	partial({
		/** Replaces the post-wastage value; wastage is not applied on top. */
		quantityOverride: number,
	})
);

export const Request = partial({
	name: string,
	additionalParameterValues: array(AdditionalParameterValue),
	// One ref per ingredient, or a LIST of refs for multi-select ingredients —
	// allowed only for projection (list-returning) formulas; the client gates
	// on `projectionUtils.isProjectionFormula`.
	ingredientsUsed: array(union(MaterialRef, array(MaterialRef))),
	// Derived projected-lines visibility, keyed by ingredient name.
	projectedLayers: record(boolean),
	layers: array(
		intersect(
			struct({
				layerId: string,
				isDeduction: boolean,
			})
		)(
			partial({
				measurement: nullable(
					partial({
						height: number,
						pitch: number,
					})
				),
			})
		)
	),
});
